import * as absences from "./absences";

const actions = {
  ...absences,
};

export default actions;
